import {createContext} from 'react';

export const DEFAULT_LEVEL_COLORS = {
    truckReady: '#2d9431',
    exterior: '#1630c2',
    interior: '#f4df1b',
    fullService: '#212121',
    // NFPA 1010 (J&B) ladder
    ff1: '#1630c2',
    ff2: '#212121',
    teamLeader: '#f57f09',
    fireOfficer1: '#e12b1e',
    fireOfficer2: '#e12b1e',
    fireOfficer3: '#e12b1e',
    fireOfficer4: '#e12b1e'
};

export const SettingsContext = createContext({
    siteName: '',
    acronym: '',
    siteSubtitle: '',
    siteFooter: '',
    allowStationLogin: false,
    usesJIBC: false,
    trainingProvider: 'jibc',
    incidentProvider: '',
    dispatchReportProvider: '',
    levelColors: {},
    taskReminders: {hour: 10, stages: {upcoming: true, due: true, overdue: true}}
});
